module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "chapter",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("PROLOGUE")]), _vm._v(" "), _c('p', {
    staticClass: "Normal1 ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("London 1797")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal1 ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("In August of 1797, a comet appears over London, splitting the night sky. To William and Mary Godwin, awaiting the birth of a child, it seems an auspicious sign. But when the babe emerges from its mother’s womb, the placenta fails to follow. A surgeon is called. Upon his arrival, everyone, even the midwife, is sent from the bedchamber. William listens at the door but can hear nothing. At last the surgeon steps into the hall, his hands covered in blood.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal1 ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("“How fares my dear wife?” William asks.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal1 ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("\t“Quite well. I was successful in my efforts.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal1 ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("\tBut the doctor is mistaken. Two days later signs of infection appear. William places the infant in the care of a nurse and then sits beside his wife’s bed. When she’s awake, he reads to her from ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The Faerie Queene")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(". After a while she whispers, “Some lines from Canto Nine, if you please.” He nods and skips ahead. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal1 ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Her fever rises and he holds a cold compress against her brow. Yet even as she fails, he refuses to pray. Among his most deeply held beliefs is that God does not exist. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal1 ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The surgeon returns but this time has nothing hopeful to say. In fact, he seems eager to be out the door. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal1 ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Mary sleeps for a few hours only to awaken soaked in sweat. With the help of a neighbor woman, William bathes her. He feeds her what she’ll accept, a little porridge, a little broth, but forgets to feed himself. She shakes so violently, he fears the bed will collapse. “Husband, save me,” she says. Then, late one night she begins finding it difficult to breathe, and before help can be summoned, she dies. She was called Mary, so the child shall be called Mary as well. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal1 ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43752276","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/A_Storm_in_the_Stars.FINALHC21.vue
// module id = 66
// module chunks = 0